<mat-card class="sim-status-card">
	<mat-card-content>
		<mat-grid-list [cols]="1">
			<div style="display: flex; justify-content: space-between;">
				@if (data.IsKa) {
					<div style="display: flex; align-items: center; margin-left: 1vw;">
						<div [ngClass]="data.KAOnline ? 'circle green-circle' : 'circle red-circle'"></div>
						<div style="flex-direction: column; text-align: left;">
							@if (data.KALastPing == null) {
								<p class="text-primary">Keep Alive Last Activity: More than a month ago</p>
							} @else {
								<p class="text-primary">Keep Alive Last Activity: {{ timeAgo(data.KALastPing) }}</p>
							}
							<p>{{ data.KALastPing }}</p>
							@if (data.KAOnline) {
								<p class="italic-text">Online</p>
							} @else {
								<p class="italic-text">Offline</p>
							}
						</div>
					</div>
				}
				@if (data.IsCdr) {
					<div style="display: flex; align-items: center; margin-left: 1vw;">
						<div [ngClass]="data.CdrOnline ? 'circle green-circle' : 'circle red-circle'"></div>
						<div style="flex-direction: column; text-align: left;">
							@if (data.CdrLastUsage == null) {
								<p class="text-primary">CDR Last Activity: More than a month ago</p>
							} @else {
								<p class="text-primary">CDR Last Activity: {{ timeAgo(data.CdrLastUsage) }}</p>
							}
							<p>{{ data.CdrLastUsage }}</p>
						</div>
					</div>
				}
				@if (data.IsMikrotik) {
					<div style="display: flex; align-items: center; margin-left: 1vw;">
						<div style="align-self: center;"
							[ngClass]="data.MikrotikOnline ? 'circle green-circle' : 'circle red-circle'"></div>

						<div style="flex-direction: column; text-align: left;">
							@if (data.MikrotikLastPing == null) {
								<p class="text-primary">Mikrotik Last Activity: More than a month ago</p>
							} @else {
								<p class="text-primary">Mikrotik Last Activity: {{ data.MikrotikLastPing }}</p>
							}
							<p>{{ data.MikrotikLastPing }}</p>
							@if (data.MikrotikOnline) {
								<p class="italic-text">Online</p>
							} @else {
								<p class="italic-text">Offline</p>
							}
						</div>
					</div>
				}
				@if (data.Usage && data.Bundle && data.SIMs?.length > 0) {
					<div style="display: flex; align-items: center;">
						<div class="circle" style="align-self: center;" [ngClass]="{
							'red-circle': data.UsageLevel == 'High' || data.UsageLevel == 'Extreme',
							'orange-circle': data.UsageLevel == 'Moderate',
							'green-circle': data.UsageLevel == 'Low',
							'grey-circle': data.UsageLevel == null || data.UsageLevel == '' || data.UsageLevel == 'No'
						}"></div>
						<div style="flex-direction: column; text-align: left;">
							<p class="text-primary">{{ data.Usage }} / {{ data.Bundle }}</p>
							<p>{{ data.CdrLastUsage }}</p>
							<p class="italic-text">{{ data.UsageLevel }} usage</p>
						</div>
					</div>
				}
				@if (data.Customer != null) {
					<div class="flex" style="display: flex; flex-direction: column; margin-right: 1vw;">
						<h4><u>Customer:</u></h4>
						<p class="text-primary">{{ data.Customer }}</p>
					</div>
				}
				@if (data.DeviceNum != null) {
					<div class="flex" style="display: flex; flex-direction: column; margin-right: 1vw;">
						<h4><u>Device Number:</u></h4>
						<p class="text-primary">{{ data.DeviceNum }}</p>
					</div>
				}
				@if (data.DeviceType != null) {
					<div class="flex" style="display: flex; flex-direction: column; margin-right: 1vw;">
						<h4><u>Device Type:</u></h4>
						<p class="text-primary">{{ data.DeviceType }}</p>
					</div>
				}
				@if (data.IMEI != null) {
					<div class="flex" style="display: flex; flex-direction: column; margin-right: 1vw;">
						<h4><u>IMEI:</u></h4>
						<p class="text-primary">{{ data.IMEI }}</p>
					</div>
				}
				@if(data.TLSEnabled){
					<div class="flex" style="display: flex; flex-direction: column; margin-right: 1vw;">
						<h4><u>TLS:</u></h4>
						<p class="text-primary" [matTooltip]="'TLS Enabled'"><mat-icon>lock</mat-icon></p>
					</div>
				}
				@if (data.Merchant != null) {
					<div class="flex" style="display: flex; flex-direction: column; margin-right: 1vw;">
						<h4><u>Merchant:</u></h4>
						<p class="text-primary">{{ data.Merchant }}</p>
					</div>
				}
				@if (data.CapSettings != null && data.CapSettings.CanEnableCapping) {
					<div class="flex" style="margin-right: 1vw;">
						<button mat-fab	(click)="presentCapConfigPopover()">
							<mat-icon>settings</mat-icon>
						</button>
					</div>
				}
				@if (data.SIMs?.length >= 1) {
					<div class="text-center margined" style="display: flex; margin-right: 1vw;">
						@for (sim of data.SIMs; track sim; let i = $index) {
						<div class="margined">
							<img (click)="presentPopover(data.SIMs[i], $event)" class="pointer"
								[ngClass]="{ 'sim-img': sim.Disabled }" width="80" height="54"
								src="{{ data.SIMs[i].Icon }}" />
							<div class="text-center">
								<div>
									<p>{{ data.SIMs[i].ServiceProvider }}</p>
								</div>
								@if (sim.Disabled) {
								<div>
									<p style="color: #cf3655">Disabled</p>
								</div>
								}
								<div>
									@if (data.ActiveSim?.length > 0 && data.SIMs[i].SimNum == data.ActiveSim) {
									<p>(Active)</p>
									}
								</div>
							</div>
						</div>
						}
					</div>
				}

				@if (data.SIMs?.length == 2 && simFailoverAllowed && data.IsMikrotik && userHasWriteAccess) {
					<div class="text-center" style="margin-right: 1vw;">
						<button mat-button (click)="initiateSimFailover()" class="simSwitchButton" shape="round"
							color="light" size="small">
							<mat-icon>swap_horiz</mat-icon>
						</button>
					</div>
				}
			</div>
		</mat-grid-list>
	</mat-card-content>
</mat-card>